

import {
    Component,
    OnInit,
  } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
  import { NGXLogger } from "ngx-logger";
import { MessageService } from "primeng/api";
  
  import {
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";
  import { Subject } from "rxjs";
import { Timestamp } from 'firebase/firestore'; 
import { Prontofibra_Firestore } from "src/app/models/prontofibra.firestore.model";
import { PfIsReady } from "src/app/models/dto/pfIsReady.model";
import { ProntofibraService } from "src/app/services/prontofibra.service";
import { ListeService } from "src/app/services/liste.service";
import { StiliService } from "src/app/services/stili.service";
import { ProntofibraDTO } from "src/app/models/prontofibra.dto.model";
  

@Component({
    selector: "component-modifica-pf",
    templateUrl: "./dialog-modifica_pf.component.html",
    styleUrls: ["../prontofibra.component.css"],
  })
  export class DialogModificaPF implements OnInit {
    protected _onDestroy = new Subject<void>();
    protected prontofibra: Prontofibra_Firestore;
    protected modificaPFForm: FormGroup;
    protected isModificandoPF:boolean = false;
    protected labelData:string ="";
    protected data:Date;

    constructor(
      private logger: NGXLogger,
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private formBuilder: FormBuilder,
      private pfService:ProntofibraService,
      private messageService: MessageService,
      protected listeService:ListeService,
      protected stiliService:StiliService
      
    ) {
      this.prontofibra          = this.config.data.prontofibra;
      if(this.prontofibra.codiceStatoProntofibra==='IN ATTESA'){
        this.labelData = " pecOde";
        if(this.prontofibra.dataPecOde){
          this.data= this.convertFirestoreTimestampToDate(this.prontofibra.dataPecOde);
        }
        
      }else if(this.prontofibra.codiceStatoProntofibra==='KO'){
        this.labelData = " Mancata installazione";
        //this.data= this.convertFirestoreTimestampToDate(this.prontofibra.dataComunicazioneProntofibra);
      }else if(this.prontofibra.codiceStatoProntofibra==='PRONTO'){
        this.labelData = " Comunicazione Pronto";
        this.data= this.convertFirestoreTimestampToDate(this.prontofibra.dataComunicazioneProntofibra);
      }else if(this.prontofibra.codiceStatoProntofibra==='ROUTER INSTALLATO'){
        this.labelData = " Installazione Router";
        this.data= this.convertFirestoreTimestampToDate(this.prontofibra.dataInstallazioneRouter);

      }else if(this.prontofibra.codiceStatoProntofibra==='SEDE ATTIVATA'){
        this.labelData = " Conferma Attivazione";
        this.data= this.convertFirestoreTimestampToDate(this.prontofibra.dataConfermaTS);
      }
      const stato = this.listeService.opzioniStatoPF.find(
        (item) => item.label === this.prontofibra.codiceStatoProntofibra
      )?.value;

      this.modificaPFForm = this.formBuilder.group({
        stato:      [ stato, [Validators.required]], 
        data:       [ this.data?this.data:null],
      });

      
      
    }
    ngOnInit() {
      this.modificaPFForm.get('stato')?.valueChanges.subscribe((nuovoStato) => {
        console.log('Nuovo valore dello stato:', nuovoStato);
        this.modificaPFForm.patchValue({ data: null });
        if(nuovoStato==='IN ATTESA'){
          this.labelData = " pecOde";
        }else if(nuovoStato==='KO'){
          this.labelData = " Mancata Installazione";
        }else if(nuovoStato==='PRONTO'){
          this.labelData = " Comunicazione Pronto";
        }else if(nuovoStato==='ROUTER INSTALLATO'){
          this.labelData = " Installazione Router";
        }else if(nuovoStato==='SEDE ATTIVATA'){
          this.labelData = " Conferma Attivazione";
        }
      });
    }
    private convertFirestoreTimestampToDate(timestamp: Timestamp): Date {
      return timestamp.toDate();
    }
  

    conferma(conferma: boolean) {
      if (!conferma) {
        this.dialogRef.close({ success: false });
      } else {
        this.isModificandoPF = true;
        let pfDaAggiornare:ProntofibraDTO     = new ProntofibraDTO();
        pfDaAggiornare.id                     = this.prontofibra.id;
        pfDaAggiornare.codiceStatoProntofibra = this.modificaPFForm.get('stato').value;
        if(pfDaAggiornare.codiceStatoProntofibra==='IN ATTESA'){
          pfDaAggiornare.dataPecOde = this.modificaPFForm.get('data').value;
        }else if(pfDaAggiornare.codiceStatoProntofibra==='KO'){
          pfDaAggiornare.dataInstallazioneRouter = this.modificaPFForm.get('data').value;
        }else if(pfDaAggiornare.codiceStatoProntofibra==='PRONTO'){
          pfDaAggiornare.dataComunicazioneProntofibra = this.modificaPFForm.get('data').value;
        }else if(pfDaAggiornare.codiceStatoProntofibra==='ROUTER INSTALLATO'){
          pfDaAggiornare.dataInstallazioneRouter = this.modificaPFForm.get('data').value;
        }else if(pfDaAggiornare.codiceStatoProntofibra==='SEDE ATTIVATA'){
          pfDaAggiornare.dataConfermaTS = this.modificaPFForm.get('data').value;
        }
  
        this.logger.info(pfDaAggiornare);
        
        this.pfService.modifica(this.prontofibra.id, pfDaAggiornare).subscribe( {
          next: (res) => {
            this.isModificandoPF = false;
            this.dialogRef.close({ success: true});
          },  error: (e) => {
            this.isModificandoPF = false;
            this.messageService.add({
              severity: "info",
              summary: "Errore" , life:10000,
                detail: "Errore in fase di modifica dello stato del Prontofibra!",
              });
            this.dialogRef.close({ success: false });
          },
          complete: () => {

          }
        } );
      } 
    }
    
  }